import React, { FC } from 'react';
import Routes from './Routes';

const App: FC = () => {
  return <Routes />;
};

export default App;
